import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent implements OnInit {
  private _isVisible: boolean;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    protected _elementRef: ElementRef<HTMLElement>,
  ) { }
  private _showTimeoutId: ReturnType<typeof setTimeout> | undefined;
  _mouseLeaveHideDelay: number;
  
  /** The timeout ID of any current timer set to hide the tooltip */
  private _hideTimeoutId: ReturnType<typeof setTimeout> | undefined;
  private readonly _onHide: Subject<void> = new Subject();
  private _closeOnInteraction = false;


  tooltip: string = 'oi mundo';
  left: number = 0;
  top: number = 0;

  ngOnInit(): void {
  }

  _triggerElement: HTMLElement;
  
  private _toggleVisibility(isVisible: boolean) {
  
    this._isVisible = isVisible;
    if (isVisible) {
      this._onShow();
    }
  }

  protected _onShow(): void {
    this._markForCheck();
  }

  _markForCheck(): void {
    this._changeDetectorRef.markForCheck();
  }

  show(delay: number): void {
    // Cancel the delayed hide if it is scheduled
    if (this._hideTimeoutId != null) {
      clearTimeout(this._hideTimeoutId);
    }

    this._showTimeoutId = setTimeout(() => {
      this._toggleVisibility(true);
      this._showTimeoutId = undefined;
    }, delay);
  }

  isVisible(): boolean {
    return this._isVisible;
  }

  _handleMouseLeave({relatedTarget}: MouseEvent) {
    if (!relatedTarget || !this._triggerElement.contains(relatedTarget as Node)) {
      if (this.isVisible()) {
        this.hide(this._mouseLeaveHideDelay);
      } 
    }
  }

  hide(delay: number): void {
    // Cancel the delayed show if it is scheduled
    if (this._showTimeoutId != null) {
      clearTimeout(this._showTimeoutId);
    }

    this._hideTimeoutId = setTimeout(() => {
      this._toggleVisibility(false);
      this._hideTimeoutId = undefined;
    }, delay);
  }

  _handleBodyInteraction(): void {
    if (this._closeOnInteraction) {
      this.hide(0);
    }
  }
  afterHidden(): Observable<void> {
    return this._onHide;
  }

  ngOnDestroy() {
    this._onHide.complete();
    this._triggerElement = null!;
  }
}
